import { Input, Button } from "antd";

import classStyles from "../../index.module.css";

import CommentAttachment from "../CommentAttachment";


const RemarkTextArea = ({
  value,
  setValue,
  handleOkButton,
  setShowEditTextArea,
  setShowTextArea,
  edit
}) => {

  return (
    <div className={classStyles["text-area"]}>
      <Input.TextArea
        value={value?.comment}
        onChange={(e) => setValue({
          ...value,
          comment: e.target.value,
        })}
        placeholder="Type your comments here..."
        autoSize={{
          minRows: 7,
          maxRows: 10,
        }}
        style={{ marginTop: "15px" }}
      />
      
      <div>
        <div className={classStyles["attachment"]}>
          <CommentAttachment 
            value={value}
            setValue={setValue}
          />
        </div>
        <div className={classStyles["buttons"]}>
          {edit && (
            <Button
            style={{ backgroundColor: 'gray', color: 'white"' }}
            onClick={() => {
              setShowEditTextArea(false);
              setShowTextArea(true)
              setValue(null)
            }}
            > Cancel </Button>
          )}

          <Button
            style={{ backgroundColor: '#FA8C16', color: 'white' }}
            onClick={handleOkButton}
          > Save </Button>
          
        </div>
      </div>
    </div>
  );
};

export default RemarkTextArea;
